import { Dropdown, Icon, Tooltip } from 'pepsico-ds'
import React from 'react'

function SingleSelectDropdown({ childList, label, selectedValue, setSelectedValue, className = "buy-con-dropdown", disabled=false, placeholder="Select", isSpGlobalScreen=false }) {
    return (
        <>
        {
            label == "Product Description" && isSpGlobalScreen ? (
                <div className='buy-con-dropdown-label' title={label} style={{display: "flex", alignItems: "center"}}>
                    <span>{label}</span>
                    <span>
                        <Tooltip direction="right" 
                            text={"It is the short label linked to a particular concept in the S&P Global dataset."}>
                            <Icon alt="" icon="info" size="small" style={{ marginLeft: "0.5rem", color: '#757474', marginTop: '2px' }}/>
                        </Tooltip>
                    </span>
                    
                </div>
            ) : (
                <>
                    <div className='buy-con-dropdown-label' title={label}>{label}</div>
                </>
            )
        }
            
            <Dropdown
                childList={childList}
                dropdownHeader="Menu List"
                isClearable={false}
                placeholder={placeholder}
                selection="single"
                size="medium"
                className={className}
                selectedValue={selectedValue}
                setSelectedValue={val => setSelectedValue(val)}
                disabled={disabled}
            />
        </>
    )
}

export default SingleSelectDropdown